import React from "react";
import { Link } from "react-router-dom";
import imgLogo from "../../assets/logo.png";

import "./styles.css";

const Render = (props, context) => {
  return (
    <section className="preSite coverAll">
      <div className="container">
        <h1 className="mbl">
          <img
            src={imgLogo}
            alt="Superheroes."
            className="logo displayBlock mha"
          />
        </h1>

        <p className="formMsg pvl mha white alignCenter">
          Chequea tu correo electrónico. Te enviamos un mail y te enviaremos un
          link para que crees tu contraseña.
        </p>

        <Link to="/" className="btn mtl mha btnGold">
          Ingresar
        </Link>
      </div>
    </section>
  );
};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/MailSent/Render.js